import React from 'react';
import { Card, CardContent, Typography, Box, alpha } from '@mui/material';

const StockSummaryCard = ({ title, value, icon, color, onClick, clickable = false }) => {
  return (
    <Card
      elevation={3}
      sx={{
        height: '100%',
        bgcolor: color,
        transition: 'all 0.3s',
        cursor: clickable ? 'pointer' : 'default',
        '&:hover': clickable ? {
          transform: 'translateY(-5px)',
          boxShadow: 8,
        } : {},
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h5" mb={1}>
              {title}
            </Typography>
            <Typography variant="h3" fontWeight="bold">
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              bgcolor: alpha('#fff', 0.2),
              borderRadius: '50%',
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StockSummaryCard;